import clsx from 'clsx'

import Text from '~/components/Text/Text'
import Button from '~/components/Button/Button'

import styles from './PillCTA.module.sass'
import { PillCTAProps } from './types'

const PillCTA: React.FC<PillCTAProps> = ({ heading, description, button: { text: buttonText, ...buttonProps } }) => {
  return (
    <div className={clsx('site-grid site-container', styles.section)}>
      <div className='col-span-full'>
        <div className={styles.content}>
          <Text variant='subheading' fontSize={[28, 28, 40]}>
            {heading}
          </Text>
          <Text fontSize={[18, 14, 18]} className={styles.description}>
            {description}
          </Text>
          <Button variant='primary' className={styles.button} {...buttonProps}>
            {buttonText}
          </Button>
        </div>
      </div>

      <div className={clsx('col-span-full', styles.background)} aria-hidden></div>
    </div>
  )
}

export default PillCTA
